exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".borderless  {\n    border: solid #ddd 1px;\n    text-align: right;\n    cursor: pointer;\n    color: #333;\n}\n\n.borderless:hover {\n    background-color: #eee;\n}\n\n.today, .today:hover {\n    background-color: #dff0d8;\n}\n\n.disabledCell, .disabledCell:hover {\n\tbackground-color: white;\n\tcolor: #ccc;\n    text-align: right;\n    cursor: default;\n} \n\n.buttonOn {\n    background-color: #e6e6e6;\n    border-color: #adadad;\n    box-shadow: inset 0 3px 5px rgba(0, 0, 0, .125);\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/assenze-prospect/assenze-prospect.component.css
// module id = 317
// module chunks = 0